<template>
    <div id="app">
        <Header></Header>
        <Nav></Nav>
        <router-view :key="$router.currentRoute.fullPath"></router-view>
        <Footer></Footer>
    </div>
</template>

<script>
    import Nav from './views/nav/index.vue';
    import Header from './views/header/index.vue';
    import Footer from './views/footer/index.vue';

    export default {
        components: {
            Nav,
            Header,
            Footer
        }
    }
</script>

<style type="text/css">
    * {
        margin: 0;
        box-sizing: border-box;
    }
    
    a {
        text-decoration: none;
    }

    .container {
        width: 88.8125rem;
        margin: 0 auto;
    }

    .info-title {
        height: 6.6875rem;
        margin: 0 auto;
        font-size: 1.125rem;
        color: #AE2D33;
        display: flex;
        align-items: center;
        justify-content: center;
        border-bottom: 1px solid rgb(239, 239, 239);
    }

    .new-icon {
        width: 2.875rem;
        height: 2.875rem;
        background-image: url(./assets/new-icon.png);
        background-size: 100% 100%;
        margin-right: 0.625rem;
    }

    .info-details {
        width: 95%;
        margin: 0 auto;
        padding-bottom: 3.125rem;
    }

    .content-item {
        cursor: pointer;
        border-bottom: 1px solid #EDEDED;
        height: 5.340625rem;
        display: flex;
        align-items: center;
        justify-content: space-between;
        color: #000000;
        font-size: 1.5625rem;
    }

    .item-left {
        cursor: pointer;
        display: flex;
        align-items: center;
    }

    .icon {
        width: 1.3125rem;
        height: 1.5625rem;
        margin-right: 1.625rem;
    }
    
    .hd {
        white-space:nowrap;
        overflow:hidden;
        text-overflow:ellipsis;
    }

    @media screen and (max-width: 1800px) {
        html {
            font-size: 14px;
        }
    }

    @media screen and (max-width: 1600px) {
        html {
            font-size: 14px;
        }
    }

    @media screen and (max-width: 1500px) {
        html {
            font-size: 13px;
        }
    }


    @media screen and (max-width: 1400px) {
        html {
            font-size: 12px;
        }
    }

    @media screen and (max-width: 1300px) {
        html {
            font-size: 11px;
        }
    }

    @media screen and (max-width: 1200px) {
        html {
            font-size: 10px;
        }
    }

    @media screen and (max-width: 1100px) {
        html {
            font-size: 9px;
        }
    }

    @media screen and (max-width: 1000px) {
        html {
            font-size: 8px;
        }
    }
</style>
